import _ from 'lodash'

export default {
	name : 'checkbox-field',
	props : ['data'],
	data () {
		return {
			fields : {},
			foo : ''
		}
	},
	methods : {
		changeData () {

			let vm = this

			vm.$emit('changeData', vm.fields)

		}
	},
	watch : {
		data : {
			handler (newData, oldData) {

				let vm = this

				for( var i in newData.value ){

					vm.fields[i] = newData.value[i]

				}

				if( vm.foo != '' ){

					vm.foo = ''

				}else{

					vm.foo = '.'

				}

				vm.$emit('changeData', vm.fields)

			},
			deep : true
		}
	},
	created () {

		let vm = this

		for( var i in vm.data.value ){

			vm.fields[i] = vm.data.value[i]

		}

	}
}


// WEBPACK FOOTER //
// ./src/components/general/fields/checkbox/script.js